import {
  Switch as MSwitch,
  FormControlLabel,
  FormHelperText,
  Box,
} from "@mui/material";
import { Field, getIn } from "formik";
import { useTranslation } from "react-i18next";
import { humanizeSettingKey } from "../utils";

export default function Switch({ id, name, boxSx = {}, onChange, disabled }) {
  const { t } = useTranslation();

  return (
    <Field name={id}>
      {({ field, form }) => {
        const touched = getIn(form.touched, field.name);
        const error = getIn(form.errors, field.name);

        // Some booleans are stored as "0"/"1" strings (Boolean("0") is true), so
        // coerce explicitly and preserve that representation on toggle — else the
        // saved value never differs from reported and looks already-synced.
        const raw = field.value;
        const checked =
          raw === true || raw === 1 || raw === "1" || raw === "true";
        const isZeroOne = raw === "0" || raw === "1";
        const emit = (next) => (isZeroOne ? (next ? "1" : "0") : next);

        return (
          <Box sx={{ px: 2, ...boxSx }}>
            <FormControlLabel
              control={
                <MSwitch
                  checked={checked}
                  disabled={disabled}
                  onChange={(e) => {
                    const next = emit(e.target.checked);
                    form.setFieldValue(field.name, next);
                    onChange?.(field.name, next);
                  }}
                />
              }
              label={t(name, { defaultValue: humanizeSettingKey(name) })}
              labelPlacement="start"
              slotProps={{
                typography: {
                  sx: { fontSize: "0.95rem" },
                },
              }}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                m: 0,
                width: "100%",
              }}
            />

            {touched && error && <FormHelperText error>{error}</FormHelperText>}
          </Box>
        );
      }}
    </Field>
  );
}
